import styled from "styled-components";
import { NB_ContextMenuProps } from "../type/contextMenu.type";

interface ExtendedSidebarProps extends NB_ContextMenuProps {
  isHidden?: boolean;
  colorText?: string;
}

const filterProps = (prop: string) => !["isHidden", "colorText"].includes(prop);

export const ContainerList = styled.article.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 154px;
  display: flex;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
  max-height: ${(props) => (props.isHidden ? "0" : "375px")};
  opacity: ${(props) => (props.isHidden ? "0" : "1")};
  overflow: hidden;
  transition: max-height 0.7s ease-in-out, opacity 0.7s ease-in-out;
  box-shadow: 0 0 12px 0 rgba(90 89 89 / 20%);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  border-radius: 8px;
`;

export const UL = styled.ul.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const LiItem = styled.li.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: 36px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background-color: #eef5fb;
  }

  padding: 5px 15px;
  box-sizing: border-box;
`;

export const ContentImageList = styled.div.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 24px;
  height: 24px;
`;

export const ImageList = styled.img.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const TitleItemList = styled.p.withConfig({
  shouldForwardProp: filterProps,
})<ExtendedSidebarProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${(props) => (props.colorText ? props.colorText : "")};
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;
